import {
  ProductCategorie,
  ProductType,
  type CommerceMapperContext,
  type CommerceSolar,
} from '@analytics/models';
import {
  analyticsRoundNumericValue,
  AnalyticsUtils,
  defaultCommerceMapperContext,
  parseTrackProductConfig,
} from '@analytics/utils';
import { inject, Injectable } from '@angular/core';

import type { SolarPanelsProductWithCalculations } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SolarPanelsProductTrackingConfig {
  readonly #analyticsUtils = inject(AnalyticsUtils);

  config = parseTrackProductConfig({
    productToCommerce: (
      product: SolarPanelsProductWithCalculations,
      context: CommerceMapperContext
    ): CommerceSolar => {
      context = {
        ...context,
        listName: this.#analyticsUtils.prefixWithAbbreviation(context.listName),
      };
      return SolarPanelsProductTrackingConfig.mapToCommerce(product, context);
    },
  });

  static mapToCommerce = (
    product: SolarPanelsProductWithCalculations,
    context: CommerceMapperContext = defaultCommerceMapperContext
  ): CommerceSolar => ({
    productNaam: product.content.title,
    productID: product.suiteCrmId,
    productType: ProductType.Solar,
    productCategorie: ProductCategorie.Zonnepanelen,
    productPositie: `${context.index}`,
    productLijst: context.listName,
    productAantal: `${product.recommendation.amount}`,
    prijs: analyticsRoundNumericValue(product.costs),
    besparing: analyticsRoundNumericValue(product.yearlySavings),
    productGarantie: `${product.productGuarantee}`,
    opbrengst: `${product.recommendation.yearlyYield}`,
    vermogen: `${product.performance}`,
    vermogensGarantie: `${product.performanceGuaranteedAfterYears}`,
  });
}
